module.exports = __webpack_public_path__ + "static/img/combined-shape.30f59733.svg";